module.exports = __webpack_public_path__ + "img/肖像_男@3x.a8ab88d4.png";